import constants from '../../constants/Constants';

export const hasScope = (scope, user) => {
  const { role, scopes } = user;
  if (role === 'admin') return true;
  return scopes?.includes(scope);
};

export const isStaff = (user) => {
  const { role } = user;
  const arrayStaff = [constants.ROLE_ADMIN, constants.ROLE_SUPERVISOR, constants.ROLE_INVENTARIOS];
  return arrayStaff.includes(role);
};

export const isOnlyMobileUser = (user) => {
  const { role } = user;
  const arrayMobile = [constants.ROLE_TENDEDOR, constants.ROLE_ESTAMPADOR, constants.ROLE_AUXILIAR];
  return arrayMobile.includes(role);
};
